<template>
  <div
    :class="{ 'bg-custom': !nightMode, 'bg-dark': nightMode }"
    class="pt-5 p-st"
  >
    <div
      class="container"
      data-aos="fade"
      data-aos-once="true"
      data-aos-duration="1000"
    >
      <div class="row align-items-center">
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12 text-center">
          <img :src="picture"/>
        </div>
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12 pt-5">
          <span 
            class="home-title"
            :class="{ pgray: nightMode, 'text-light': nightMode }"
            >AI Manager &nbsp;&nbsp;&nbsp;&nbsp;  <img class="company_logo" style="width:120px; height:auto;" src="https://www.lundbeck.com/content/dam/lundbeck-com/masters/global-site/media-library/images/logo/LUNDBECK-logo-RGB.png.coredownload.png"> <br><br></span
          >
          <div>
            <p v-html="description"></p>
          </div>
          <div class="text-center pb-4">
            <button
              class="btn social-btn mx-2"
              @click="open('linkedin')"
              v-tooltip.bottom="'LinkedIn'"
            >
              <i class="fab fa-linkedin"></i>
            </button>
            <button
              class="btn social-btn mx-2"
              @click="open('github')"
              v-tooltip.bottom="'GitHub'"
            >
              <i class="fab fa-github"></i>
            </button>
            <button
              class="btn social-btn mx-2"
              @click="open('instagram')"
              v-tooltip.bottom="'Instagram'"
            >
              <i class="fab fa-instagram"></i>
            </button>
            <button
              class="btn social-btn mx-2"
              @click="open('twitter')"
              v-tooltip.bottom="'Twitter'"
            >
              <i class="fab fa-twitter"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

import Wave from "./helpers/Wave";

export default {
  name: "Home",
  components: {
    Wave,
  },
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      picture: info.flat_picture,
      description: info.description,
      name: info.name,
      linkedin: info.links.linkedin,
      github: info.links.github,
      instagram: info.links.instagram,
      twitter: info.links.twitter
    };
  },
  methods: {
    open(link) {
      switch (link) {
        case "linkedin":
          window.open(this.linkedin, "_blank");
          break;
        case "github":
          window.open(this.github, "_blank");
          break;
        case "instagram":
          window.open(this.instagram, "_blank");
          break;
        case "twitter":
          window.open(this.twitter, "_blank");
          break;
      }
    },
  },
};
</script>

<style scoped>
.home-title {
  font-size: 28px;
  font-weight: 500;
}

img {
  max-width: 200px;
  margin-top: 60px;
  margin-bottom: 50px;
  border-radius: 10px;

  /*transform: rotateY(180deg); */
}

@media only screen and (max-width: 580px) {
  img {
    object-fit: cover;
    border-radius: 50%;
    height: 200px;
    width: 200px;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 2px solid rgb(205, 205, 205);
  }
}

.fa {
  font-size: 15px;
}

.social-btn {
  border-color: rgba(255, 255, 255, 0.7);
  color: #fff;
  border-radius: 50%;
  width: 42px;
  height: 42px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  font-size: 16px;
}

.social-btn:hover {
  background-color: #fff;
  border-color: #fff;
  color: #02aab0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.social-btn:focus {
  outline: none !important;
  box-shadow: none;
}

p {
  text-align: justify;
  font-weight: 400;
}

/* LEAVES */
</style>
